import { createAsyncThunk } from '@reduxjs/toolkit';

import APIDataProvider, { TApiResponse } from '../../../api/ApiDataProvider';
import { ICurriculumV2, ICurriculumWithGrade, IGradeV2 } from '.';
import { ApiPaths } from '../../../api/APIPaths';

const apiDataProvider = new APIDataProvider();

export const getCurriculumsV2 = createAsyncThunk(
  '/curriculumsV2/list',
  async () => {
    const response = await apiDataProvider.get<TApiResponse<ICurriculumV2[]>>(
      ApiPaths.curriculums
    );

    return response.data;
  }
);

export const getCurriculumsV2WithGrades = createAsyncThunk(
  '/curriculumsV2/list-with-grades',
  async () => {
    const response = await apiDataProvider.get<
      TApiResponse<ICurriculumWithGrade[]>
    >(`${ApiPaths.curriculums}/list-with-grades`);

    return response.data;
  }
);

export const getGradesV2 = createAsyncThunk(
  '/curriculumsV2/grades/list',
  async () => {
    const response = await apiDataProvider.get<TApiResponse<IGradeV2[]>>(
      `${ApiPaths.curriculums}/grades`
    );

    return response.data;
  }
);
